package frontend

import AuthorizationUI
import androidx.compose.runtime.*
import com.ionspin.kotlin.bignum.decimal.BigDecimal
import frontend.lib.Router
import frontend.models.Address
import frontend.models.User
import frontend.pages.LoaderUI
import frontend.pages.PasswordRequestUI
import kotlinx.browser.window
import kotlinx.coroutines.GlobalScope
import kotlinx.coroutines.flow.collect
import kotlinx.coroutines.flow.onEach
import kotlinx.coroutines.launch
import net.sergeych.bintools.defaultNamedStorage
import net.sergeych.crypto2.VerifyingPublicKey
import net.sergeych.crypto2.initCrypto
import net.sergeych.mp_logger.Log
import net.sergeych.ugdx.GuestAPI
import net.sergeych.ugdx.ServiceState
import net.sergeych.ugdx.shared.ApiException
import net.sergeych.ugdx.shared.Currency
import net.sergeych.ugdx.shared.api.ApiAccount
import net.sergeych.ugdx.shared.trader.CurrencyPair
import net.sergeych.ugdx.shared.trader.Trader
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.Text
import org.jetbrains.compose.web.renderComposable
import org.w3c.dom.Location

class App(val api: GuestAPI) {
    var currencies: List<Currency> by mutableStateOf(emptyList())
    var pairs: List<CurrencyPair> by mutableStateOf(emptyList())
    var isLoading: Boolean by mutableStateOf(false)
    var dustzaiBid: BigDecimal? by mutableStateOf(null)

    //    var currentScreen by mutableStateOf(Screen.Wallet)
//    var storage = KVStorage(MemoryKVBinaryStorage())
    var state by mutableStateOf(api.stateFlow.value)
    var user: User? by mutableStateOf(null)
    var deposit: DepositContext? by mutableStateOf(null)
    var checkBalance: Boolean by mutableStateOf(true)

    val router = Router()
//    window.onpopstate = function(event) {

    fun searchParams(): Map<String, String> {
        val map = mutableMapOf<String, String>()
        val hash = window.location.hash
        val searchRaw = hash.split("?")
        if (searchRaw.size > 1) {
            val searchString = searchRaw[1]
            val parts = searchString.split("&")

            for (p in parts) {
                val keyval = p.split("=")
                map.put(keyval[0], keyval[1])
            }
        }

        return map
    }
//    var routeInvoiceId: String? by mutableStateOf(null)
//    var routeLogin: String? by mutableStateOf(null)

//    fun loadRoute() {
//        val hash = window.location.hash
//        val parts = hash.split("/")
//        if (parts.size > 2) routeInvoiceId = parts.last()
//
//        var searchRaw = hash.split("?")
//        if (searchRaw.size > 1) {
//            var searchString = searchRaw[1]
//            var parts = searchString.split("&")
//
//            for (p in parts) {
//                var keyval = p.split("=")
//                if(keyval[0] == "iid") routeInvoiceId = keyval[1]
//                if(keyval[0] == "l") routeLogin = keyval[1]
//            }
//        }
//    }

//    
//    fun show(screen: Screen) { currentScreen = screen }
}

fun initTailwind() {
    kotlinext.js.require("./styles.css")
}

@Suppress("unused")
val testServiceId = VerifyingPublicKey.parse("I1po9Y2I7p2aOxeh4nFyGPm3e0YunBEu1Mo-PmIqP84Evg")

suspend fun initAPI() {
    initCrypto()
    Log.connectConsole(Log.Level.DEBUG)

    val storage = defaultNamedStorage("ugdx")
    val l: Location = window.location
    if ("reset=1" in l.search) {
        println("Clearing local storage by request, session will be lost")
        storage.clear()
    } else {
        println("Local storage data was not clear and could be reused")
    }

    try {
        GuestAPI.init(
//            url = if (window.location.host.startsWith("localhost"))
//                "ws://localhost:8090/kp"
//            else
//                "wss://unitedgold.io/kp",
                "wss://exch.dassets.xyz/kp",
            storage = storage,
        )
        println("API LOADED")
    } catch (err: Throwable) {
        println("Guest API init error, $err")
        err.printStackTrace()
//        window.location.search = "?reset=1"
    }

//    Log.connectBrowserConsole()
}

data class DepositContext(
    val to: ApiAccount,
    val amount: String = "",
    val from: Address?,
    val isOpen: Boolean = false,
)

@Composable
fun AppUI(app: App) {
    val state = app.state

    when (state) {
        is ServiceState.NotSignedIn -> AuthorizationUI(app)
        is ServiceState.SignedIn -> {
            if (app.isLoading) LoaderUI()
            else app.user?.let { DashboardUI(app, it) }
        }

        is ServiceState.PasswordRequest -> PasswordRequestUI(state)
        is ServiceState.Loading -> LoaderUI()
    }
}

fun main() {
//    globalLaunch { initAPI() }
    renderComposable(rootElementId = "root") {
        var waitInit by remember { mutableStateOf(true) }

        LaunchedEffect(Unit) {
            initAPI()
            GuestAPI.deferredApi.await()
            waitInit = false
        }
        if (waitInit) {
            Div({
                style {
                    position(Position.Fixed)
                    top(0.px)
                    left(0.px)
                    width(100.vw)
                    height(100.vh)
                    background("#330599")
                }
            }) {
                H1({
                    style {
                        position(Position.Relative)
                        top(40.percent)
                        textAlign("center")
                        color(Color.white)
                    }
                }) {
                    Text("Initializing...")
                }
            }
        } else {
            showUi()
        }
    }
}

@Composable
fun showUi() {
    val app = remember { App(GuestAPI.deferredApi.getCompleted()) }

    window.onpopstate = {
        app.router.setRoute()
    }
//        app.loadRoute()

    GlobalScope.launch {
        initTailwind()

        app.currencies = GuestAPI().getCurrencies()
        app.pairs = Trader.currencyPairs()

        GuestAPI().stateFlow.onEach {
            println("==================== New state is $it ====================")
            val state = it

            if (state is ServiceState.SignedIn) {
                println("==== hasDecryptedKeys = ${state.userAccount.hasDecryptedKeys()}")
                println("==== allowExchangeAccess = ${state.userAccount.canUseExchange}")
                val user = app.user

                if (user == null) {
                    println("==== User just logged in")
                    app.user = User(state.userAccount)
                } else {
                    if (user.userAccount != state.userAccount) {
                        println("==== Got new user")
                        app.user = User(state.userAccount)
                    } else {
//                    user.userAccount = state.userAccount
//                    app.user = user
                    }
                }

                try {
                    app.user?.load()
                    if (window.location.search == "?reset=1") window.location.search = ""
                } catch (e: ApiException) {
                    window.location.search = "?reset=1"
                }
            }

            app.state = it

        }.collect()
    }
    AppUI(app)
}
